import { mergeStyleSets, getTheme } from "@fluentui/react";

const theme = getTheme();

export const styles = mergeStyleSets({
  rolloutDetailsFormLoadingSpinner: {
    position: "absolute" as const,
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    background: `${theme.palette.white}B3`, // 70% opacity equivalent
    zIndex: 10,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },

  rolloutDetailsFormOverlay: {
    position: "absolute" as const,
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    background: `${theme.palette.white}B3`, // 70% opacity equivalent
    zIndex: 10,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },

  rolloutDetailsFormError: {
    color: theme.palette.redDark,
    border: `${theme.palette.redDark} solid 1px`,
    padding: "8px",
    borderRadius: "4px",
  },

  rolloutDetailsTemplateChoice: {
    marginBottom: "16px",
  },

  rolloutDetailsFormPanelContent: {
    display: "flex",
    flexDirection: "column" as const,
  },

  rolloutDetailsFormContainer: {
    minHeight: "200px",
  },

  rolloutDetailsFormFields: {
    display: "flex",
    flexDirection: "column" as const,
    justifyContent: "space-between",
  },

  rolloutDetailsFormField: {
    marginBottom: "16px",
  },

  rolloutDetailsFormActions: {
    display: "flex",
    justifyContent: "flex-end",
    gap: "12px",
    padding: "10px",
  },
});
